import { render, staticRenderFns } from "./person-withdrawal-dialog.vue?vue&type=template&id=fc9bd62a&scoped=true&"
import script from "./person-withdrawal-dialog.vue?vue&type=script&lang=js&"
export * from "./person-withdrawal-dialog.vue?vue&type=script&lang=js&"
import style0 from "./person-withdrawal-dialog.vue?vue&type=style&index=0&id=fc9bd62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9bd62a",
  null
  
)

export default component.exports